import styled from "styled-components";

export const FloatingMouseContentWrapper = styled.div`
    display: block;
    width: 100%;
`;